import { getMenuList } from '../../api/user'
// 懒加载 注意，动态加载路由需要
const loadView = (view) => {
  return (resolve) => view && view !== '/' && require([`@/views${view}`], resolve).catch(() => {})
}

const state = {
  functionKey: [],
  routes: [],
  addRoutes: [],
  menuList: []
}

const mutations = {
  SET_FUNCTIONLIST: (state, functionKey) => {
    state.functionKey = functionKey
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  },
  // 保存原始菜单数据
  SET_ORIGIN_MENU_LIST: (state, list) => {
    state.menuList = list
  }
}

const defaultMenuList = [
  {
    'id': 90,
    'menuName': 'Upload List',
    'parentId': 0,
    'menuType': 1,
    'menuKey': 'uploadrecord',
    'iconClass': 'icon-dingdanguanli',
    'link': '/uploadrecord',
    'sort': 762,
    'isCache': 0,
    'isScreen': 0,
    'systemId': 10,
    'systemCode': 'prime',
    'urlProfix': '90033',
    'childNode': []
  },

  {
    'id': 100,
    'menuName': 'Home',
    'parentId': 0,
    'menuType': 1,
    'menuKey': 'home',
    'iconClass': 'icon-dingdanguanli',
    'link': '/home',
    'sort': 1,
    'isCache': 0,
    'isScreen': 0,
    'systemId': 10,
    'systemCode': 'prime',
    'urlProfix': '90033',
    'childNode': []
  },

  {
    'id': 200,
    'menuName': 'B/L',
    'parentId': 0,
    'menuType': 1,
    'menuKey': 'bl-parent',
    'iconClass': 'icon-dingdanguanli',
    'link': null,
    'sort': 2,
    'isCache': 0,
    'isScreen': 0,
    'systemId': 10,
    'systemCode': 'prime',
    'urlProfix': '90033',
    'childNode': [
      {
        'id': 201,
        'menuName': 'Dashboard',
        'parentId': 200,
        'menuType': 1,
        'menuKey': 'dashboard',
        'iconClass': 'icon-dingdanguanli',
        'link': '/dashboard',
        'sort': 1,
        'isCache': 0,
        'isScreen': 0,
        'systemId': 10,
        'systemCode': 'prime',
        'urlProfix': '90033',
        'childNode': []
      },
      {
        'id': 202,
        'menuName': 'B/L Upload',
        'parentId': 200,
        'menuType': 1,
        'menuKey': 'bl',
        'iconClass': 'icon-dingdanguanli',
        'link': '/bl',
        'sort': 2,
        'isCache': 0,
        'isScreen': 0,
        'systemId': 10,
        'systemCode': 'prime',
        'urlProfix': '90033',
        'childNode': []
      }
    ]
  },
  {
    'id': 300,
    'menuName': 'Truck',
    'parentId': 0,
    'menuType': 1,
    'menuKey': 'truck-parent',
    'iconClass': 'icon-dingdanguanli',
    'link': null,
    'sort': 3,
    'isCache': 0,
    'isScreen': 0,
    'systemId': 10,
    'systemCode': 'prime',
    'urlProfix': '90033',
    'childNode': [
      {
        'id': 301,
        'menuName': 'Truck Inquiry',
        'parentId': 300,
        'menuType': 1,
        'menuKey': 'truck-inquiry',
        'iconClass': 'icon-dingdanguanli',
        'link': '/truckinquiry',
        'sort': 1,
        'isCache': 0,
        'isScreen': 0,
        'systemId': 10,
        'systemCode': 'prime',
        'urlProfix': '90033',
        'childNode': []
      },
      {
        'id': 302,
        'menuName': 'Review List',
        'parentId': 300,
        'menuType': 1,
        'menuKey': 'truck-review',
        'iconClass': 'icon-dingdanguanli',
        'link': '/truckreview',
        'sort': 2,
        'isCache': 0,
        'isScreen': 0,
        'systemId': 10,
        'systemCode': 'prime',
        'urlProfix': '90033',
        'childNode': []
      },
      {
        'id': 303,
        'menuName': 'Mark Up',
        'parentId': 300,
        'menuType': 1,
        'menuKey': 'truckmarkup',
        'iconClass': 'icon-dingdanguanli',
        'link': '/truckmarkup',
        'sort': 3,
        'isCache': 0,
        'isScreen': 0,
        'systemId': 10,
        'systemCode': 'prime',
        'urlProfix': '90033',
        'childNode': []
      }
    ]
  },
  {
    'id': 400,
    'menuName': 'Order',
    'parentId': 0,
    'menuType': 1,
    'menuKey': 'order',
    'iconClass': 'icon-dingdanguanli',
    'link': '/order',
    'sort': 4,
    'isCache': 0,
    'isScreen': 0,
    'systemId': 10,
    'systemCode': 'prime',
    'urlProfix': '90033',
    'childNode': []
  },
  {
    'id': 500,
    'menuName': 'Tax',
    'parentId': 0,
    'menuType': 1,
    'menuKey': 'tax',
    'iconClass': 'icon-dingdanguanli',
    'link': '/tax',
    'sort': 5,
    'isCache': 0,
    'isScreen': 0,
    'systemId': 10,
    'systemCode': 'prime',
    'urlProfix': '90033',
    'childNode': []
  }

]

const actions = {
  // 配置系统菜单
  getUserMenuList({ commit }) {
    return new Promise((resolve, reject) => {
      const model = {
        appId: '',
        appIds: [7],
        enableAppFilter: true
      }
      let routeList = []
      getMenuList(model).then(response => {
        const { data } = response
        if (data) {
          // 所有按钮权限
          commit('SET_FUNCTIONLIST', getFunctionKey(data.menuFunctionList))

          // 获取用户信息，判断是否为 reviewer 角色
          const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
          const username = userInfo?.userName || userInfo?.realName || localStorage.getItem('username') || ''
          const allowedRoles = ['reviewer', 'PRIM1Y']
          const isAllowedUser = allowedRoles.includes(username)

          // 显示的菜单数据
          let list = [...data.menuList, ...defaultMenuList]

          // 如果不是 reviewer 角色，过滤掉特定菜单（id: 100, 200, 300, 400, 500）
          if (!isAllowedUser) {
            const restrictedMenuIds = [100, 200, 300, 400, 500]
            list = filterRestrictedMenus(list, restrictedMenuIds)
          }

          // // 显示的菜单数据
          // const list = [...data.menuList, ...defaultMenuList]

          // 处理菜单连接
          commit('SET_ORIGIN_MENU_LIST', filterAsyncMenu(list))
          // 处理路由
          routeList = filterAsyncRouter(list)
        }
        commit('SET_ROUTES', routeList)
        resolve(routeList)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

// 递归过滤受限制的菜单
function filterRestrictedMenus(menuList, restrictedIds) {
  if (!menuList || menuList.length === 0) {
    return []
  }

  return menuList
    .filter(menu => !restrictedIds.includes(menu.id))
    .map(menu => ({
      ...menu,
      childNode: menu.childNode && menu.childNode.length
        ? filterRestrictedMenus(menu.childNode, restrictedIds)
        : []
    }))
}

// 组装功能key
function getFunctionKey(data) {
  if (data && data.length > 0) {
    return data.map(item => item.functionKey)
  }
  return []
}

// 菜单递归处理连接
function filterAsyncMenu(list) {
  if (!list || list.length === 0) {
    return []
  }
  const func = (list, isLayout) => {
    return list.map(item => {
      const menuItem = {}
      setFactLink(menuItem, item, isLayout)
      const childNode = item.childNode || []
      return {
        ...item,
        ...menuItem,
        childNode: childNode.length ? func(item.childNode, false) : null
      }
    })
  }
  return func(list, true)
}
// 路由遍历
function filterAsyncRouter(menuList) {
  const routerList = []
  // 刷新
  routerList.push({
    // path: '/redirect',
    hidden: true,
    path: '/redirect/:path(.*)',
    component: () => import('@/redirect/index')
  })
  if (menuList === null || menuList.length === 0) {
    return routerList
  }
  // 遍历后台传来的路由字符串，转换为组件对象
  menuList.forEach(menu => {
    // 记录页面的路径包含当前
    menu.parentPath = '/' + menu.menuKey

    var router = routerConvert(menu, true)
    // 是否存在子节点，
    if (menu.childNode && menu.childNode.length) {
      var list = []
      getChildMenu(menu.childNode, list, router.parentPath)
      if (list.length > 0) {
        list.forEach(child => {
          child.parentPath = menu.parentPath + '/' + child.menuKey
          routerList.push(routerConvert(child, false))
        })
      }
    }
    routerList.push(router)
  })
  return routerList
}
// 路由转换
function routerConvert(menu, isLayout) {
  var router = {}
  router.name = menu.menuKey
  router.parentPath = menu.parentPath

  setFactLink(router, menu, isLayout)

  router.id = menu.id
  router.menuType = menu.menuType
  const rootPath = '/' + menu.menuKey
  if (isLayout) {
    // Layout组件特殊处理
    router.component = loadView(menu.link)
    router.path = rootPath
  } else {
    // var link = rootPath + (menu.link ? menu.link : '')
    // 处理组件---重点
    // 不带参数
    if (menu.link.indexOf(':') === -1) {
      router.component = loadView(menu.link)
    } else {
      // 带参数
      const link = menu.link.substring(0, menu.link.indexOf(':') - 1)
      router.component = loadView(link)
    }
    router.path = (menu.link ? menu.link : '')
  }
  var meta = {}
  meta.title = menu.menuName
  meta.keepAlive = !!menu.isCache
  if (menu.iconCloass) {
    // 默认图标处理
    meta.icon = menu.iconCloass
  } else {
    meta.icon = 'user'
  }
  // 页面是否需要菜单和头部布局
  meta.isScreen = !!menu.isScreen
  meta.parentPath = menu.parentPath
  router.meta = meta
  // 是否是页面
  if (menu.menuType === 2) {
    router.hidden = true
  }
  return router
}

// 判断是当前应用的路由还是其他系统，其他系统转成https访问，当前系统使用路由访问
// 若是第三方外链，则不作任何处理
function setFactLink(router, menu, isLayout) {
  // 是否是外链（指本公司系统内的非当前应用）
  if (isLayout) {
    // 因为接口数据如果是layout，返回的link为null，需要手动设置根路由
    // router.link = '/' + Vue.prototype.$appId
    router.link = '/' + menu.menuKey
  } else {
    // 当前应用，直接赋值
    // router.link = '/' + Vue.prototype.$appId + menu.link
    router.link = menu.link
  }
}

// 递归获取子节点 parentPath=上级菜单的路径
function getChildMenu(childList, list, parentPath) {
  childList.forEach(item => {
    // 存储上级或本机菜单的路径
    if (parentPath) {
      item.parentPath = parentPath + '/' + item.menuKey
    }
    if (item.link) {
      list.push(item)
    }
    if (item.childNode && item.childNode.length > 0) {
      getChildMenu(item.childNode, list, item.parentPath)
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
